<span *transloco="let t" class="spinner-border" role="status">
  <span class="visually-hidden">{{t('LOADING')}}</span>
</span>
